import { LockIcon } from '../Icons.js';

export interface EliteSectionDividerProps {
  /** Whether user has elite-tier entitlement */
  isEliteTier: boolean;
}

export function EliteSectionDivider({ isEliteTier }: EliteSectionDividerProps) {
  return (
    <div className="elite-divider">
      <div className="elite-divider-line" />
      <div className="elite-divider-content">
        <h3 className="elite-divider-title">Elite Threat Intelligence</h3>
        <p className="elite-divider-subtitle">Advanced forensic blockchain analysis for professionals</p>
        {!isEliteTier && (
          <div className="elite-divider-lock-row">
            <LockIcon className="elite-divider-lock-icon" aria-hidden="true" />
            <span className="elite-divider-lock-text">Pro feature preview</span>
            <a href="/pricing" className="elite-divider-upgrade-btn">
              Upgrade to Elite
            </a>
          </div>
        )}
      </div>
      <div className="elite-divider-line" />
    </div>
  );
}
